/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "com.atproto.identity.resolveHandle";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"handle":/*#__PURE__*/ l.string({"format":"handle"})});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"did":/*#__PURE__*/ l.string({"format":"did"})});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Resolves an atproto handle (hostname) to a DID. Does not necessarily bi-directionally verify against the the DID document. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["HandleNotFound"]);

export { main };

export const $lxm = $nsid;
